<template>
  <div class="seat-block">
    <div class="seat-wrap" :class="[
      specialDesignation == 1 ? 'front' : '',
      specialDesignation == 2 ? 'rear' : '',
    ]">
      <div v-if="specialDesignation != 2" class="train-number">
        {{ carNumber }}号車　
        <span v-if="specialDesignation == 0">一般席</span>
        <span v-else-if="specialDesignation == 1">前展望席</span>
      </div>

      <div v-if="
        carNumberVacancyStatus.car.boarding_gate_position ==
        'forward' && specialDesignation == 0
      " class="gate">
        乗車口
      </div>
      <div v-else-if="
        carNumberVacancyStatus.car.boarding_gate_position == 'forward_only_metro'
        && specialDesignation == 0
      " class="gate">
        乗車口(東京メトロ線内のみ)
      </div>

      <!-- 席行 -->
      <!-- 1行5席(真ん中の通路含む)なので総席数/5 = 総席行 -->
      <div class="row" v-for="row_index in carNumberVacancyStatus.seats.length / 5" :key="row_index">
        <!-- index==2は通路となるので常に非表示 -->
        <div v-for="(seat, index) in carNumberVacancyStatus.seats.slice(
          (row_index - 1) * 5,
          (row_index - 1) * 5 + 5
        )" :key="seat.display_number" :style="[index == 2 ? { display: 'none' } : '']">
          <!-- 一般・前後展望それぞれで席のステイタスが違うので、表示されるべきかを管理 -->
          <button v-if="isMatchAttribute(seat.seat_attribute)" class="seat-button"
            :class="[getClassForSpecialSeat(seat.seat_attribute), checkSelected(seat).flag ? 'select' : '']"
            type="button" :disabled="!seat.vacancy" @click="arrangeSelectedSeat(seat)">
            {{ seat.display_number }}
          </button>
        </div>

        <!-- 窓の表示 -->
        <MFITTSeatWindow :trainType="selectedTrainInfo.cars_formation.name.slice(0, 3)"
          :carNumber="carNumber" :specialDesignation="specialDesignation" :rowIndex="row_index"
          :rowNumber="carNumberVacancyStatus.seats.length / 5" :bound="carNumberVacancyStatus.bound" />
      </div>
      <!-- 席行 -->

      <div v-if="
        carNumberVacancyStatus.car.boarding_gate_position == 'back' &&
        specialDesignation == 0
      " class="gate">
        乗車口
      </div>
      <div v-else-if="
        carNumberVacancyStatus.car.boarding_gate_position == 'back_only_metro'
        && specialDesignation == 0
      " class="gate">
        乗車口(東京メトロ線内のみ)
      </div>

      <div v-if="specialDesignation == 2" class="train-number">
        {{ carNumber }}号車　
        <span>後展望席</span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useVModel } from "vue-composable";
import { CAR_SPECIAL_DESIGNATIONS_MAP, COMMON_SPECIAL_DESIGNATIONS_MAP } from "@/lib/constants";
export default {
  name: "MFITTSeatMap",

  props: {
    specialDesignation: {
      type: String,
      required: false,
    },
    carNumber: {
      type: Number,
      required: false,
    },
    carNumberVacancyStatus: {
      type: Object,
      required: false,
      default: null,
    },
    selectedSeat: {
      type: Array,
      required: false,
      default: null,
    },
    inputtedInfoOnBooking: {
      type: Object,
      required: false,
      default: null,
    },
    selectedTrainInfo: {
      type: Object,
      required: false,
    },
  },
  emits: ["checkSeatsCount"],
  setup(props, { emit }) {
    const selectedSeat = useVModel(props, "selectedSeat");

    // 座席がすでに選ばれているかをチェックする
    const checkSelected = computed(() => {
      return function (seat) {
        let flag;
        let index;
        selectedSeat.value.some(function (ob, i) {
          if (
            ob.car_number === props.carNumberVacancyStatus.car.number &&
            ob.seat.seat_number === seat.seat_number
          ) {
            flag = true;
            index = i;
          }
        });
        return { flag: flag, index: index };
      };
    });

    // 座席ボタンが叩かれたとき、その座席がすでに選ばれているかをチェックしその結果に応じて追加・削除を行う
    const arrangeSelectedSeat = (seat) => {
      const some = checkSelected.value(seat);
      if (some.flag) {
        selectedSeat.value.splice(some.index, 1);
        emit("checkSeatsCount", false);
      } else {
        // 選択された人数を超えないようにする
        if (
          selectedSeat.value.length <
          props.inputtedInfoOnBooking.adult_count +
            props.inputtedInfoOnBooking.child_count
        ) {
          console.log("object :>> なし");
          const object = {
            car_number: props.carNumberVacancyStatus.car.number,
            seat: seat,
          };
          selectedSeat.value.push(object);
        }
        if (
          selectedSeat.value.length ==
          props.inputtedInfoOnBooking.adult_count +
            props.inputtedInfoOnBooking.child_count
        ) {
          emit("checkSeatsCount", true);
        }
      }
    };

    // 一般か前後展望によって表示すべきステイタスが違うので管理
    const isMatchAttribute = (attribute) => {
      switch (props.specialDesignation) {
        case COMMON_SPECIAL_DESIGNATIONS_MAP.GENERAL:
        case CAR_SPECIAL_DESIGNATIONS_MAP.A:
        case CAR_SPECIAL_DESIGNATIONS_MAP.B:
        case CAR_SPECIAL_DESIGNATIONS_MAP.C:
        case CAR_SPECIAL_DESIGNATIONS_MAP.D:
        case CAR_SPECIAL_DESIGNATIONS_MAP.E:
        case CAR_SPECIAL_DESIGNATIONS_MAP.F:
        case CAR_SPECIAL_DESIGNATIONS_MAP.G:
        case CAR_SPECIAL_DESIGNATIONS_MAP.H:
        case CAR_SPECIAL_DESIGNATIONS_MAP.I:
        case CAR_SPECIAL_DESIGNATIONS_MAP.J:
          return attribute == 1 ||
            attribute == 5 ||
            attribute == 6 ||
            attribute == 9
            ? true
            : false;
        case COMMON_SPECIAL_DESIGNATIONS_MAP.FRONT_VIEW:
          return attribute == 2 ? true : false;
        case COMMON_SPECIAL_DESIGNATIONS_MAP.REAR_VIEW:
          return attribute == 3 ? true : false;
      }
    };

    // 席種別によってデザインが異なる場合がある
    const getClassForSpecialSeat = (attribute) => {
      var _class = "";
      switch (attribute) {
        case "5": // 車椅子席
          _class = "wc-seat-button";
          break;
        case "6": // 介護席
          _class = "care-seat-button";
          break;
      }
      return _class;
    };

    return {
      selectedSeat,
      checkSelected,
      arrangeSelectedSeat,
      isMatchAttribute,
      getClassForSpecialSeat,
    };
  },
};
</script>

<style lang="scss" scoped>
.seat-block {
  width: 100%;
}

.seat-block .seat-wrap {
  border: 6px solid #c32a2a;
  background-color: #f7e7d2;
  border-radius: 12px;
  padding: 8px 8px;
  position: relative;
}

.seat-block .front {
  border-top-right-radius: 190px;
  border-top-left-radius: 190px;
  padding-top: 50px;
}

.seat-block .rear {
  border-bottom-right-radius: 190px;
  border-bottom-left-radius: 190px;
  padding-bottom: 50px;
}

.seat-block .seat-wrap .row {
  display: flex;
  justify-content: space-between;
  margin: 6px 0;
}

.seat-block .seat-wrap .row div {
  width: 24%;
}

.seat-button {
  background-color: #ffffff;
  border: 2px solid #c9713a;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  width: 100%;
  height: 40px;
  color: #c9713a;
  font-size: 18px;
  font-weight: bold;
  margin-right: 8px;
  padding: 1px 6px;
}

.seat-button:last-of-type {
  margin-right: 0;
}

.seat-button:nth-of-type(2) {
  margin-right: 18px;
}

.seat-button.select {
  background-color: #ffb206;
  border-color: #ffdc8e;
  color: #ffffff;
}

.seat-button:disabled {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(201, 113, 58, 0.2);
  color: rgba(201, 113, 58, 0.2);
}

.seat-block .seat-wrap .train-number {
  text-align: center;
  width: 100%;
  margin: 14px 0;
  color: #000000;
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
}

.seat-block .front .train-number {
  padding-bottom: 50px;
}

.seat-block .seat-wrap .gate {
  background-color: #066796;
  text-align: center;
  width: 100%;
  margin: 14px 0;
  padding: 12px 0;
  color: #ffffff;
  font-size: 16px;
  line-height: 16px;
  font-weight: normal;
}

.seat-block .rear .train-number {
  padding-top: 50px;
}

.wc-seat-button {
  background-image: url('~@/assets/img/icon/svg/icon-wc-seat.svg');
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: 5px 50%;
  background-color: rgba(255, 255, 255, 1);
  border: 2px solid rgba(255, 181, 201, 1);
  color: rgba(221, 109, 139, 1);
  text-align: right;
}

.wc-seat-button.select {
  background: none;
  background-image: url('~@/assets/img/icon/svg/icon-wc-seat-wt.svg');
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: 5px 50%;
  background-color: rgba(255, 178, 6, 1);
  border-color: rgba(255, 220, 142, 1);
  color: rgba(255, 255, 255, 1);
}

.wc-seat-button:disabled {
  background-image: url('~@/assets/img/icon/svg/icon-wc-seat-tr.svg');
  background-color: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 181, 201, 0.2);
  color: rgba(221, 109, 139, 0.2);
}

.care-seat-button {
  background-image: url('~@/assets/img/icon/svg/icon-care-seat.svg');
  background-repeat: no-repeat;
  background-size: 26px;
  background-position: 5px 50%;
  background-color: rgba(255, 255, 255, 1);
  border: 2px solid rgba(131, 175, 235, 1);
  color: rgba(58, 118, 201, 1);
  text-align: right;
}

.care-seat-button.select {
  background: none;
  background-image: url('~@/assets/img/icon/svg/icon-care-seat-wt.svg');
  background-repeat: no-repeat;
  background-size: 26px;
  background-position: 5px 50%;
  background-color: rgba(255, 178, 6, 1);
  border-color: rgba(255, 220, 142, 1);
  color: rgba(255, 255, 255, 1);
}

.care-seat-button:disabled {
  background-image: url('~@/assets/img/icon/svg/icon-care-seat-tr.svg');
  background-color: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(131, 175, 235, 0.2);
  color: rgba(58, 118, 201, 0.2);
}
</style>
